import React from "react";
import DataField from "../../utils/DataField";
import { checkNested, formatAddress, formatAsMoney } from "../../utils/utils";
import { useTranslation } from "react-i18next";

function FinalBeneficiaries(props) {
  const { t } = useTranslation();

  if (
    props.legal_person.final_beneficiaries === undefined ||
    props.legal_person.final_beneficiaries.length === 0
  ) {
    return (
      <div
        className="analysisCard"
        style={{ minHeight: "250px", height: "100%" }}
      >
        <div className={["blueText", "subtitleSize"].join(" ")}>
          {t("final_beneficiaries")}
        </div>
        <div style={{ display: "flex", flexGrow: "1" }}>
          <div
            className={["labelText", "normalMediumSize"].join(" ")}
            style={{ margin: "auto" }}
          >
            {t("information_unavailable")}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="analysisCard" style={{ height: "100%" }}>
      <div className={["blueText", "subtitleSize"].join(" ")}>
        {t("final_beneficiaries")}
      </div>
      {checkNested(props.legal_person, "final_beneficiaries") &&
        props.legal_person.final_beneficiaries.map(
          (beneficiary, index) => (
            <div
              key={index}
              className="internalCardContainer"
              style={{ display: "flex", flexDirection: "column" }}
            >
              {props.legal_person.final_beneficiaries.length !== 1 && (
                <div
                  className={["normalText", "normalMediumSize", "bold"].join(
                    " "
                  )}
                  style={{ marginBottom: "10px" }}
                >{`${[index + 1]}. ${t("final_beneficiary")}`}</div>
              )}
              {checkNested(beneficiary, "name") && (
                <DataField
                  title={t("name")}
                  label={beneficiary.name}
                  size={"normalMediumSize"}
                  titleNoWrap={true}
                />
              )}
              {
                <DataField
                  title={t("document_number")}
                  label={
                    checkNested(beneficiary, "document_number")
                      ? beneficiary.document_number
                      : "Dado não recebido"
                  }
                  size={"normalMediumSize"}
                  titleNoWrap={true}
                />
              }
              {
                <DataField
                  title={t("address")}
                  label={
                    checkNested(beneficiary, "address")
                      ? formatAddress(beneficiary.address)
                      : "Dado não recebido"
                  }
                  size={"normalMediumSize"}
                  titleNoWrap={true}
                />
              }
              {
                <DataField
                  title={t("declared_income")}
                  label={
                    checkNested(beneficiary, "declared_income")
                      ? formatAsMoney(beneficiary.declared_income)
                      : "Dado não recebido"
                  }
                  size={"normalMediumSize"}
                  titleNoWrap={true}
                />
              }
            </div>
          )
        )}
    </div>
  );
}

export default FinalBeneficiaries;
